<template>
    <div>
        <v-stepper v-model="e1" class="elevation-0">
            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-card
                        class="mb-12"
                        flat
                    >
                    <v-form 
                        v-model="validStep1"
                        ref="step1"
                        lazy-validation
                        @submit.prevent="verifyValidUserPasw"
                    >
                    <v-card-title class="font-weight-bold">Signing Up with {{ registerType == 'email' ? 'Email Address' : 'Phone Number'}}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col sm="12" md="6">
                                <div class="subtitle">{{$t('First Name')}}<span class="red--text">*</span></div>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="user.firstName"
                                    :rules="rules.name"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6">
                                <div class="subtitle">{{$t('Last Name')}}<span class="red--text">*</span></div>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="user.lastName"
                                    :rules="rules.lastname"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8"  v-if="registerType=='email'">
                                <div class="subtitle">{{$t('Email')}}<span class="red--text">*</span></div>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="user.email"
                                    :rules="rules.email"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8"  v-if="registerType=='mobile'">
                                <div class="subtitle">{{$t('Phone Number')}}<span class="red--text">*</span></div>
                                <v-row no-gutters class="d-flex">
                                    <v-col cols="5">
                                        <v-autocomplete
                                            style="background-color: #1F5D51;"
                                            outlined
                                            :items="countries"
                                            item-value="MobileCode"
                                            class="phone-drop rounded-r-0 outline-l-0"
                                            v-model="user.countryCode"
                                            :filter="filterCountry"
                                            dense
                                            ref="phoneSelect"
                                            hide-details
                                            :rules="rules.countryCode"
                                            @change="phoneSelected"
                                        >
                                            <template v-slot:item="slotProps">
                                                <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i> &nbsp;
                                                {{` (+${slotProps.item.MobileCode }) ${slotProps.item.Name}` }}
                                            </template>
                                            <div class="truncate" slot="selection" slot-scope="data" style="color:white; font-size:12px; font-weight:bold;">
                                                <span >
                                                    <!-- <i :class="['em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>&nbsp; -->
                                                    {{`( +${data.item.MobileCode } )` }}
                                                </span>
                                            </div>
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="7">
                                        <v-text-field
                                            type="number"
                                            class="rounded-l-0"
                                            outlined
                                            dense
                                            v-model="user.mobile"
                                            :rules="rules.mobile"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Password')}}<span class="red--text">*</span></div>
                                <v-text-field
                                    :type="passwordType"
                                    outlined
                                    dense
                                    v-model="user.password"
                                    :rules="rules.password"
                                    prepend-inner-icon="mdi-lock-outline"
                                    :append-icon="passwordIcon"
                                    @click:append="changePasswordType('password')"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Confirm Password')}}<span class="red--text">*</span></div>
                                <v-text-field
                                    :type="confirmPasswordType"
                                    outlined
                                    dense
                                    v-model="confirmPassword"
                                    :rules="rules.confirmPassword"
                                    prepend-inner-icon="mdi-lock-outline"
                                    :append-icon="confirmPasswordIcon"
                                    @click:append="changePasswordType('confirmPassword')"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="primary"
                            @click="$router.push('/register')"
                            outlined
                        >
                        Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            type="submit"
                        >
                        NEXT
                        </v-btn>
                    </v-card-actions>
                    </v-form>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-card
                        class="mb-12"
                        flat
                    >
                    <v-form 
                        v-model="validStep2"
                        ref="step2"
                        lazy-validation
                        @submit.prevent="validateStepTwocParams"
                    >
                    <v-card-title class="font-weight-bold">Signing Up with {{ registerType == 'email' ? 'Email Address' : 'Phone Number'}}</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col sm="12" md="6">
                                <div class="subtitle">{{$t('Country')}}<span class="red--text">*</span></div>
                                <v-autocomplete
                                    outlined
                                    :items="countries"
                                    item-value="Code"
                                    class="rounded-r-0 outline-l-0 crs-p text-no-wrap"
                                    :filter="filterCountry"
                                    dense
                                    v-model="user.countryId"
                                    :rules="rules.countryId"
                                >
                                    <template v-slot:item="slotProps">
                                        <i :class="['mr-2', 'em', `em-flag-${slotProps.item.Code.toLowerCase()}`]"></i>
                                        {{`${slotProps.item.Name}`}}
                                    </template>
                                    <template class="d-flex" slot="selection" slot-scope="data">
                                        <i :class="['mr-2', 'em', `em-flag-${data.item.Code.toLowerCase()}`]"></i>
                                        <span  class="text-no-wrap">{{`${data.item.Name}`}}</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col sm="12" md="6">
                                <div class="subtitle">{{$t('Province / State')}}<span class="red--text">*</span></div>
                                <v-text-field
                                    placeholder="Enter Province/State"
                                    outlined
                                    dense
                                    v-model="user.stateId"
                                    :rules="rules.stateId"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Village / Town / City')}}<span class="red--text">*</span></div>
                                <v-text-field
                                placeholder="Enter village/town/city"
                                outlined
                                dense
                                v-model="user.village"
                                :rules="rules.village"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Address')}}</div>
                                <v-text-field
                                placeholder="Enter your address"
                                outlined
                                dense
                                v-model="user.address"
                                ></v-text-field>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Website')}}</div>
                                <v-text-field
                                placeholder="Enter your website"
                                outlined
                                dense
                                v-model="user.website"
                                ></v-text-field>
                            </v-col>
                            <!-- <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('User Organization')}}</div>
                                <v-text-field
                                placeholder="Enter your organization"
                                outlined
                                dense
                                v-model="user.organizationCode"
                                ></v-text-field>
                            </v-col> -->
                            <!-- <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('User Role')}}<span class="red--text">*</span></div>
                                <v-select
                                    multiple
                                    :items="rolesList"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                                    dense
                                    v-model="user.userRole"
                                ></v-select>
                            </v-col>
                            <v-col sm="12" md="6" class="mt-n8">
                            </v-col> -->
                            <!-- <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Family Tribe')}}</div>
                                <v-text-field
                                placeholder="Enter your family tribe"
                                outlined
                                dense
                                v-model="user.userTribe"
                                ></v-text-field>
                            </v-col> -->
                            <v-col sm="12" md="6" class="mt-n8">
                                <div class="subtitle">{{$t('Language')}}</div>
                                <v-select
                                    :items="languages"
                                    item-text="name"
                                    item-value="code"
                                    outlined
                                    dense
                                    v-model="user.language"
                                ></v-select>
                            </v-col>
                       
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            class="ml-2"
                            color="primary"
                            @click="e1 = 1"
                            outlined
                        >
                        BACK
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            type="submit"
                        >
                        NEXT
                        </v-btn>
                    </v-card-actions>
                    </v-form>
                    </v-card>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-card
                        class="mb-12"
                        flat
                    >
                    <v-card-title class="font-weight-bold">Upload Profile Picture</v-card-title>
                    <v-card-text>
                         <div class="form">
                                <!-- <div v-if="!file"> -->
                                  
                                <div style="overflow: clip" :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                                    <div class="dropZone-info" @drag="onChange">
                                        <span class="fa fa-cloud-upload dropZone-title"></span>
                                        <span class="dropZone-title"  v-if="!previewUrl" >
                                            <v-icon size="120"  color="gray">mdi-account</v-icon>
                                        </span>
                                        <!-- <div class="d-flex-start">
                                            <div class="primary--text">Browse </div>
                                        </div> -->
                                        <div class="dropZone-upload-limit-info">
                                            <div id="preview" >
                                                <img v-if="previewUrl" :src="previewUrl" width="440" />
                                            </div>
                                            <div>Drag Your Profile  Image here </div>
                                        </div>
                                    </div>
                                    <input type="file"  accept="image/png, image/gif, image/jpeg" @change="onChange">
                                </div>
                               
                                    <span class="red--text">{{ fileError }}</span>
                                <!-- </div> -->
                                <!-- <div v-else class="dropZone-uploaded" style="overflow: clip;">
                                 
                                    <div class="dropZone-uploaded-info">
                                    <v-btn
                                        class="ma-2 white--text"
                                        @click="removeFile"
                                        color="primary"
                                        outlined
                                    >
                                        Remove File
                                        <v-icon
                                            right
                                            dark
                                        >
                                            mdi-trash-can
                                        </v-icon>
                                    </v-btn>
                                    </div>
                                </div> -->
                            
                                <div v-if="file" class="uploadedFile-info">
                                    <div>{{ file.name }}</div>
                                </div>
                            </div>
                            <div class="d-flex justify-center mt-7">
                                <vue-recaptcha @verify="captchaVerify" @expired="captchaExpired" sitekey="6LffNccfAAAAAMdqGdGgnu-BT_WkaTflyx3FZh3s"></vue-recaptcha>
                            </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="primary"
                            outlined
                            @click="e1=2"
                        >
                        Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="registerUser"
                            :disabled="!captcha"
                        >
                        SIGN UP
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-stepper-content>
                <v-stepper-content step="4">
                    <v-card
                        class="mb-12"
                        flat
                    >
                        <div class="text-center text-h4 font-weight-black">OTP Verification</div>
                        <v-card-text class="text-center flex-direction-box">
                            <div class="vertical-center black--text">
                                <h2 class="font-weight-black black-text">Enter 6 digits Code</h2>
                                <p class="caption">Enter the 6 digits code that you received on your email or mobile number.</p>
                                <div class="ma-auto position-relative" style="max-width: 300px">
                                    <v-otp-input
                                        v-model="otp"
                                        length="6"
                                        plain
                                    ></v-otp-input>
                                </div>
                                <!-- <p class="body-1 mt-10">Didn't receive OTP? 
                                    <v-btn @click="registerUser2"  color="primary" class="body-1 px-0 pb-1 btn" plain depressed> Resend OTP</v-btn>
                                .</p> -->
                            </div>
                        </v-card-text>
                         <v-card-actions>
                            <v-btn
                                color="primary"
                                @click="e1 = 3"
                                outlined
                            >
                            Back
                            </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="verifyOTP"
                            :disabled="!isOTPActive"
                        >
                        VERIFY
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <v-dialog
            v-model="dialog"
            max-width="500"
            persistent
        >
            <v-card class="pt-8 pb-5" max-width="500">
                <v-card-text class="d-flex justify-center">
                    <v-card flat max-width="300"> 
                        <v-img style="margin:auto;" src="/icons/userinfo.png" width="70"></v-img>
                        <v-card-title class="justify-center">
                            <div>
                                <h3 class="headline">Congratulations</h3>
                            </div>
                        </v-card-title>
                        <v-card-text class="text-center">
                            <p>Your account is now verified and approved</p>
                        </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="primary"
                            @click="$router.push({name:'Login'})"
                            block
                            max-width="30"
                        >
                            Login
                        </v-btn>
                    </v-card-actions>
                    </v-card>
                </v-card-text>
        </v-card>
    </v-dialog>
</div>
</template>
<script>
import UserService from "@/_services/UserService"
import loadingMixin from "@/mixins/LoadingMixin";
import generalMixin from "@/mixins/GeneralMixin";
import { VueRecaptcha } from 'vue-recaptcha';
import countries from "@/constants/countries.js"
import languages from "@/constants/languages.js"



export default {
    async mounted() {
        const fetchData = async () => {
            this.startLoading()
            this.rolesList = await UserService.getAppUserRoles();
            this.stopLoading();
        }
        await fetchData();
    },
    components: {
		VueRecaptcha
	},
    props: {
        registerType: {
            type: String,
            require: true
        }
    },
    computed: {
      isOTPActive () {
        return this.otp.length === 6
      },
    },
    data() {
        return {
            previewUrl: '',
            captcha: false,
            otp: '',
            rolesList: [],
            countries,
            languages,
            validStep1: true,
            validStep2: true,
            e1: 1,
            file: '',
            fileError: '',
            dragging: false,
            dialog: false,
            phoneS: false,
            user: {
                userId: '',
                countryCode: 1,
                email: "",
                password: "",
                organizationCode: process.env.DEFAULT_ORG || "dimitra",
                mobile: "",
                firstName: "",
                lastName: "",
                language: "en",
                userRole: ["farmer"],
                address: "",
                countryId: "US",
                countryIsoCode:"US",
                stateId: "",
                district: "",
                village: "",
                userTribe: "",
                website: "",
                resendOTP: false
            },
            confirmPassword: "",
            rules: {
                name: [
                    v => !!v || 'Firstname is required',
                    v => (v && v.length <= 25) || 'Firstname must be less than 25 characters',
                ],
                lastname: [
                    v => !!v || 'Lastname is required',
                    v => (v && v.length <= 25) || 'Lastname must be less than 25 characters',
                ],
                email: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                password: [
                    v => !!v || 'Password is required',
                ],
                confirmPassword: [
                    v => !!v || 'Confirm Password is required',
                    v => (this.user.password === v) || 'Passwords should be same.'
                ],
                countryId: [
                    v => !!v || 'Country is required',
                ],
                stateId: [
                    v => !!v || 'State is required',
                ],
                village: [
                    v => !!v || 'Village/Town/City is required',
                ],
                mobile: [
                    v => !!v || 'Mobile is required',
                ],
                countryCode: [
                    v => !!v || 'Country code is required',
                ],
            },
            passwordType: 'password',
            confirmPasswordType: 'password',
            passwordIcon: 'mdi-eye',
            confirmPasswordIcon: 'mdi-eye',
        }
    },
    methods: {
        verifyValidUserPasw() {
            if (!this.$refs.step1.validate()) return;
            // console.log(this.user);
            var d = {
                password: this.user.password
            }

            if(this.registerType == 'mobile'){
                d.mobile = this.user.mobile;
            }

            if(this.registerType == 'email'){
                d.email = this.user.email
            }


            this.startLoading();
            UserService.checkAlreadyExistedUser(d)
            .then((result) => {
                if(result.statusCode == 200) {
                        this.e1 = 2;
                }else if(result.statusCode == 409){
                        this.$notify({
                            title: 'Duplicate User.',
                            text: 'User already exist in system.',
                            type: 'error'
                        });
                    
                } else {
                    throw new Error("Server Error");
                }
                this.stopLoading();
            }).catch((err) => {
                console.log('error',err);
                this.stopLoading();
            });
        },

        validateStepTwocParams() {
            if (!this.$refs.step2.validate()) return;
            this.e1 = 3
        },

        registerUser() {

            let formData = new FormData();
            for (var key in this.user) {
                formData.append(key, this.user[key]);
            }
            formData.append("isLivestockUser", true);
            formData.append("app_type", "livestock_guru");
            formData.append("profilePic", this.file);
            this.startLoading();
            UserService.registerUser(this.registerType, formData)
            .then(res => {
                this.stopLoading();
                if(res.statusCode == 200 && res.status == true){
                    this.e1 = 4;
                    this.$notify({
                        title: res.message,
                        type: 'success'
                    });
                }else{
                    this.$notify({
                        title: res.message,
                        type: 'error'
                    });
                }
            })
            .catch(err => {
                // console.log('rrr', err.response.data.message);
                this.stopLoading();
                this.$notify({
                    title: err.response.data.message || 'Something went wrong.',
                    type: 'error'
                });
            })
        },
        registerUser2() {

            let formData = new FormData();
            this.user.resendOTP = true;
            for (var key in this.user) {
                formData.append(key, this.user[key]);
            }
            formData.append("countryIsoCode",  this.user.countryId);
            formData.append("isLivestockUser", true);
            formData.append("app_type", "livestock_guru");
            formData.append("profilePic", this.file);
            this.startLoading();
            UserService.registerUser(this.registerType, formData)
            .then(res => {
                this.stopLoading();
                if(res.code == 200 && res.success == true){
                    this.e1 = 4;
                    this.$notify({
                        title: res.message,
                        type: 'success'
                    });
                }else{
                    this.$notify({
                        title: res.message,
                        type: 'error'
                    });
                }
            })
            .catch(err => {
                // console.log('rrr', err.response.data.message);
                this.stopLoading();
                this.$notify({
                    title: err.response.data.message || 'Something went wrong.',
                    type: 'error'
                });
            })
        },

        sendOTP(){
            const data = {
                mobile: this.user.mobile,
                countryCode: this.user.countryCode,
                password: this.user.password
            }
            console.log(data)
            UserService.sendOTP(this.registerType, data)
            .then( res => {
                if(res.code == 200 && res.success == true){
                    this.$notify({
                        title: res.message,
                        type: 'success'
                    });
                }else{
                    throw new Error('Incorrect OTP.');
                }
                this.stopLoading();
            })
            .catch(() => {
                this.$notify({
                    title: "Incorrect OTP",
                    type: 'success'
                });
                this.stopLoading();
            })
        },

        verifyOTP() {
            // console.log(this.otp)
            this.startLoading();
            UserService.verifyOTP({
                credential: this.registerType == 'email' ? this.user.email: this.user.mobile,
                otp: this.otp,
                licenseKey: ""
            })
            .then( res => {
                if(res.statusCode == 200 && res.status == true){
                    this.dialog = true;
                }else{
                    throw new Error('Incorrect OTP.');
                }
                this.stopLoading();
            })
            .catch(() => {
                this.$notify({
                    title: "Incorrect OTP",
                    type: 'success'
                });
                this.stopLoading();
            })
        },

        onChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            
            const file = e.target.files[0];
            this.previewUrl = URL.createObjectURL(file);
            if (!files.length) {
                this.dragging = false;
                return;
            }
            
            this.createFile(files[0]);
        },
        createFile(file) {
            this.file = file;
            console.log(this.file)
            this.dragging = false;
        },
        removeFile() {
            this.file = '';
        },

        captchaVerify(res){
			this.captchaCode = res;
			this.captcha = true;
		},
		captchaExpired(){
			this.captcha = false;
		},

        phoneSelected() {
			this.$refs.phoneSelect.blur();
		},
        changePasswordType(type) {
            if (type === 'password') {
                if(this.passwordType == 'password'){
                this.passwordType = 'text';
                this.passwordIcon = 'mdi-eye-off'
                } else {
                this.passwordType = 'password';
                this.passwordIcon = 'mdi-eye'
                }
            } else if (type === 'confirmPassword') {
                if(this.confirmPasswordType == 'password'){
                this.confirmPasswordType = 'text';
                this.confirmPasswordIcon = 'mdi-eye-off'
                } else {
                this.confirmPasswordType = 'password';
                this.confirmPasswordIcon = 'mdi-eye'
                }
            }
		},
    },
    mixins: [loadingMixin, generalMixin]
}
</script>
<style lang="scss" scoped>
    ::v-deep .phone-drop .v-input__slot {
        padding-right: 0px !important;
    }

.dropZone {
    width: 100%;
    height: 450px;
    position: relative;
    border: 2px dashed #97A8B8;
}

.dropZone:hover {
  border: 2px solid $primary-color;
}

.dropZone:hover .dropZone-title {
  color: $primary-color;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
    color: #787878; 
}

.dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    overflow: clip;
}

.dropZone-over {
    background: #5C5C5C;
    opacity: 0.8;
    overflow: clip;
}

.dropZone-uploaded {
    width: 100%;
    height: 450px;
    position: relative;
    border: 2px solid $primary-color;
    overflow: clip;
    // border-radius: 10px;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
  overflow: clip;
}

.removeFile {
  width: 200px;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.flex-direction-box {
	height: 30em;
	max-height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
.btn {
    text-transform: unset !important;
}

::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input {
    margin-top: -10in;
}
</style>